import { IntentType } from '@40seas/entities/intents';
import { User } from '@auth0/auth0-react';
import { z } from 'zod';
import { EnumSchema } from '../SchemaOperations';

export enum ExecutorType {
    Event = 'event',
    Application = 'application',
    User = 'user',
    System = 'system',
}

export const ExecutorSchema = z
    .object({
        id: z.string().optional(),
        type: EnumSchema(ExecutorType),
        intentType: EnumSchema(IntentType)
            .optional()
            .openapi({
                enum: [
                    'Checkout',
                    'Invoice',
                    'PaymentMethod',
                    'Order',
                    'Onboard',
                    'CreditLine',
                    'BuyerSignup',
                    'BuyerInvoice',
                    'Signup',
                    'CreateBuyer',
                    'FinancialConnection',
                    'RegisteredUser',
                ],
            }),
    })
    .openapi({ required: [] })
    .strict();

export interface Executor {
    type: ExecutorType;
    id?: string;
    intentType?: IntentType;
    user?: string | User;
}
